
















































































import CrossPageTransition from '@/mixin/cross-page-transition'
import _ from 'lodash'
import Vue from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { AuthErrorEvent } from '@/components/organisms/dialog/error-dialog/events'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { URL } from '@/util/url'
import ShortcutLoginArea from '@spa/components/organisms/cart/auth/ShortcutLoginArea.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CookieService } from '@spa/services/cookie'
import { CartLoginTemplateParts, loadingTemplate } from './model/login/template-parts'
import { createCartLoginTemplateParts } from './model/login/template-parts-factory'

import HostPageLinkMixin from '@/mixin/HostPageLink'
import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { User } from '@spa/store/modules/user/types'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    ShortcutLoginArea,
  },
  mixins: [
    LoadingMixin,
    HostPageLinkMixin,
  ],
})
export default class CartLogin extends Mixins<PluginMixin & CrossPageTransition>(PluginMixin, CrossPageTransition) {
  @Prop({ required: true })
  /**
   * ルーティング設定からの注入が基本
   */
  readonly next: string

  status: Status = Status.Pending

  email: string | null = null

  /**
   * @deprecated
   *
   * 本来はEngine側で対応するべきものなので、この実装は暫定的な対応である。
   * @see https://github.com/Everforth/growthpalette-front/issues/8851
   */
  latestSubmittedEmailContainsUppercase: boolean = false

  password: string | null = null

  showModal: boolean = false

  showExternalLoginModal: boolean = false

  templateParts: CartLoginTemplateParts = loadingTemplate

  get user(): User {
    return this.$store.state.user.user
  }

  get behavior(): BehaviorConfig {
    return new BehaviorConfig()
  }

  get hasExternalLoginError(): boolean {
    return _.get(this.$route.query, 'external-login-error') === 'true'
  }

  get errorOnLogin() {
    return _.get(this.$store.state.user.error, 'login')
  }

  get hasError(): boolean {
    return !!this.errorOnLogin
  }

  get hasTooManyRequestsError(): boolean {
    const error = this.errorOnLogin

    if (!error) {
      return false
    }

    const { status } = error

    // tslint:disable-next-line:no-magic-numbers
    return status === 429
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  get urlToContinueShopping() {
    return this.$store.getters['history/urlToContinueShopping']
  }

  get brandName(): string | null {
    const brandQueryName = 'brand'

    return URL.getQuery(location.href, brandQueryName)
  }

  async created() {
    this.templateParts = createCartLoginTemplateParts(this.behavior)

    await this.$store.dispatch('user/get')
    await this.setUrlToContinueShopping()

    EventBusForThirdParty.getInstance().publish('page-initialized', {
      url: window.location.href,
      initializedAt: CurrentTime.create().now,
      user: this.user,
    })
  }

  async beforeRouteEnter(to, _from, next) {
    if (CookieService.isRegistered()) {
      next({
        path: this.next,
        query: to.query,
      })

      return
    }
    next()
  }

  async mounted() {
    if (this.hasExternalLoginError) {
      this.showExternalLoginModal = true

      this.emitError({
        content: Vue.extend({
          template: `
            <p>ご利用のブランドの会員情報でログインできませんでした。</p>
            <p>※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。</p>
          `,
        }),
      })
    }
  }

  async setUrlToContinueShopping() {
    await this.$store.dispatch('history/setUrlToContinueShopping')
  }

  async validateForm(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async submit() {
    const validated = await this.validateForm()

    if (!validated) {
      return
    }

    this.status = Status.Loading

    this.latestSubmittedEmailContainsUppercase = /[A-Z]/.test(this.email!)

    await this.$store.dispatch('user/login', {
      username: this.email,
      password: this.password,
    })

    if (this.hasError) {
      this.showModal = true
      this.status = Status.Failed

      /**
       * interaction が分離されたので、ログイン画面と統合できそう
       * @see client/spa/src/components/pages/auth/login/model/interaction.ts
       */
      this.emitError({
        content: this.hasTooManyRequestsError
          ? `<p>
            ただ今このユーザはログインできません。<br>
            お手数ですがしばらく経ってから再度ログインして下さい。
          </p>`
          : `<p>
            ログインできませんでした。<br>
            正しいメールアドレスとパスワードを入力してください。<br>
            ${this.latestSubmittedEmailContainsUppercase
              ? '※メールアドレスに大文字が含まれています。小文字でのログインをお試しください。'
              : ''
            }
          </p>`,
      })

      return
    }

    await this.$store.commit('init')

    this.goTo(this.next, () => {
      this.status = Status.Completed
    })
  }

  @Emit('error')
  private emitError(_event: AuthErrorEvent) {
    // only emit event
  }
}
